/* ==========================================================================
   Lovelle — hairline.js (Lovelle Dab & Go, product.hairline.json)
   Loaded only on that template, after bra.js (both deferred, in that order).
   bra.js already owns the packs, the per-stick <select>s, the chips it draws
   over them (data-bra-chips), the add-to-cart, reviews and lightbox. This
   file adds:

   1. The shade block above the packs: one tap puts that shade on every
      stick in every pack, turns the gallery to its packshot and updates the
      line that says who the shade is for. Arrow keys move between shades.
   2. Real colours on bra.js's chips (data-hex from Liquid) and the shade
      name beside each stick row.
   3. "Mix shades": opens a shade row per stick in the chosen pack; turning
      it off puts every stick back on the shade chosen above.
   4. The sticky bar follows the chosen pack (name + total) and adds it; until
      a shade has been chosen it scrolls to the shade block first.
   5. "Find your shade" cards choose a shade and go back to the packs.
   6. The before / after slider, and smooth in-page links under the header.

   No user-facing string is written here; every word is already in the DOM.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-hl-root]');
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function headerOffset() {
    var h = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-h'), 10);
    return (isNaN(h) ? 64 : h) + 14;
  }
  function scrollToEl(el, center) {
    if (!el) return;
    if (center) { el.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' }); return; }
    var y = el.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    window.scrollTo({ top: y, behavior: reduced ? 'auto' : 'smooth' });
  }

  /* ---- 6b: in-page links (stars under the title, "see all reviews") ---- */
  qsa('[data-hl-scroll]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = qs(a.getAttribute('data-hl-scroll'));
      if (!target) return;
      e.preventDefault();
      scrollToEl(target, false);
      if (history.replaceState) history.replaceState(null, '', a.getAttribute('data-hl-scroll'));
    });
  });

  /* ---- 6a: before / after ---- */
  qsa('[data-hl-ba]').forEach(function (ba) {
    var range = qs('[data-hl-ba-range]', ba);
    if (!range) return;
    function set(v) { ba.style.setProperty('--pos', v + '%'); }
    range.addEventListener('input', function () { set(range.value); });
    ['pointerdown', 'touchstart'].forEach(function (ev) {
      range.addEventListener(ev, function () { ba.classList.add('is-dragging'); }, { passive: true });
    });
    ['pointerup', 'touchend', 'pointercancel', 'blur'].forEach(function (ev) {
      range.addEventListener(ev, function () { ba.classList.remove('is-dragging'); }, { passive: true });
    });
    set(range.value);
  });

  if (!root) return;
  var bundle = qs('[data-bra-bundle]', root);
  if (!bundle) return;

  var product = null;
  try { product = JSON.parse(qs('[data-bra-product-json]', root).textContent); } catch (e) { product = null; }
  var shadePos = parseInt(bundle.getAttribute('data-color-pos'), 10) || 0;

  /* ---- Sold-out shades ---- */
  var soldOut = [];
  if (product && product.variants && shadePos) {
    var anyAvailable = {};
    var all = [];
    product.variants.forEach(function (v) {
      var c = v.options[shadePos - 1];
      if (all.indexOf(c) < 0) all.push(c);
      if (v.available !== false) anyAvailable[c] = true;
    });
    all.forEach(function (c) { if (!anyAvailable[c]) soldOut.push(c); });
  }

  var selects = qsa('select[data-bra-color]', bundle);
  var block = qs('[data-hl-shade]', root);
  var swatches = block ? qsa('[data-hl-swatch]', block) : [];
  var currentEl = block ? qs('[data-hl-shade-current]', block) : null;
  var hintEl = block ? qs('[data-hl-shade-hint]', block) : null;
  var mix = qs('[data-hl-mix]', bundle);
  var chosen = false;
  var globalShade = null;

  /* ---- 2: paint the chips bra.js drew, and the name beside each row ---- */
  selects.forEach(function (sel) {
    var chips = sel.parentNode.querySelector('.brachips');
    if (!chips) return;
    qsa('.brachips__opt', chips).forEach(function (btn) {
      var value = btn.getAttribute('data-value');
      var opt = Array.prototype.filter.call(sel.options, function (o) { return o.value === value; })[0];
      var dot = btn.querySelector('.brachips__dot');
      if (opt && dot && opt.getAttribute('data-hex')) dot.style.background = opt.getAttribute('data-hex');
      if (opt && dot && opt.getAttribute('data-img')) dot.style.backgroundImage = 'url(' + opt.getAttribute('data-img') + ')';
      if (soldOut.indexOf(value) > -1) {
        btn.setAttribute('data-oos', 'true');
        btn.setAttribute('aria-disabled', 'true');
      }
    });
  });
  function paintRow(sel) {
    var pick = sel.closest('[data-bra-pick]');
    var name = pick ? pick.querySelector('[data-hl-pick-name]') : null;
    if (name) name.textContent = sel.value;
  }
  selects.forEach(paintRow);

  /* ---- 1: the shade block ---- */
  swatches.forEach(function (sw) {
    if (soldOut.indexOf(sw.getAttribute('data-value')) > -1) {
      sw.setAttribute('data-oos', 'true');
      sw.setAttribute('aria-disabled', 'true');
    }
  });

  function paintBlock(value) {
    swatches.forEach(function (sw) {
      var on = sw.getAttribute('data-value') === value;
      sw.classList.toggle('is-active', on);
      sw.setAttribute('aria-checked', on ? 'true' : 'false');
      sw.tabIndex = on ? 0 : -1;
      if (on && hintEl) hintEl.textContent = sw.getAttribute('data-hint') || '';
    });
    if (currentEl) currentEl.textContent = value;
  }

  function showPhoto(value) {
    var sw = swatches.filter(function (s) { return s.getAttribute('data-value') === value; })[0];
    var pos = sw ? parseInt(sw.getAttribute('data-slide'), 10) : NaN;
    if (isNaN(pos) || typeof window.LovelleShowSlide !== 'function') return;
    window.LovelleShowSlide(pos - 1);
    var thumbs = qs('.brapdp__thumbs', root);
    if (thumbs && pos > 4) thumbs.classList.remove('is-collapsed');
  }

  function setAll(value, photo) {
    globalShade = value;
    selects.forEach(function (sel) {
      if (sel.__bra) sel.__bra.set(value, true); else sel.value = value;
      paintRow(sel);
    });
    paintBlock(value);
    if (photo) showPhoto(value);
  }

  swatches.forEach(function (sw, i) {
    sw.addEventListener('click', function () {
      if (sw.getAttribute('data-oos') === 'true') return;
      chosen = true;
      setAll(sw.getAttribute('data-value'), true);
    });
    sw.addEventListener('keydown', function (e) {
      var step = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : (e.key === 'ArrowLeft' || e.key === 'ArrowUp') ? -1 : 0;
      if (!step) return;
      e.preventDefault();
      var next = swatches[(i + step + swatches.length) % swatches.length];
      next.focus();
      next.click();
    });
  });

  // Start on the preselected shade, or the first one that can be bought.
  if (swatches.length) {
    var start = (swatches.filter(function (s) { return s.classList.contains('is-active'); })[0] || swatches[0]);
    if (start.getAttribute('data-oos') === 'true') {
      start = swatches.filter(function (s) { return s.getAttribute('data-oos') !== 'true'; })[0] || start;
    }
    setAll(start.getAttribute('data-value'), false);
  }

  /* ---- 3: mix shades ---- */
  if (mix) {
    mix.addEventListener('change', function () {
      bundle.classList.toggle('is-mixing', mix.checked);
      if (!mix.checked && globalShade) setAll(globalShade, false);
      if (mix.checked) chosen = true;
    });
  }

  bundle.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('select[data-bra-color]')) { paintRow(t); chosen = true; return; }
    if (t.matches('input[data-bra-tier]')) { paintSticky(t, true); bump(qs('[data-bra-total]', bundle)); }
  });

  /* ---- 4: the sticky bar ---- */
  var sticky = qs('[data-hl-sticky]', root);
  var stickyName = sticky ? qs('[data-hl-sticky-name]', sticky) : null;
  var stickyTotal = sticky ? qs('[data-hl-sticky-total]', sticky) : null;
  var stickyBuy = sticky ? qs('[data-hl-sticky-buy]', sticky) : null;
  var addBtn = qs('[data-bra-add]', bundle);

  function bump(el) {
    if (!el || reduced) return;
    var host = el.closest('.brabundle__add') || el;
    host.classList.remove('is-bump');
    void host.offsetWidth;
    host.classList.add('is-bump');
  }
  function paintSticky(input, animate) {
    if (!input) return;
    if (stickyName) stickyName.textContent = input.getAttribute('data-name') || stickyName.textContent;
    if (stickyTotal) {
      stickyTotal.textContent = input.getAttribute('data-total') || stickyTotal.textContent;
      if (animate) bump(stickyTotal);
    }
  }
  paintSticky(qs('input[data-bra-tier]:checked', bundle), false);

  if (stickyBuy) {
    stickyBuy.addEventListener('click', function () {
      if (!chosen && block) {
        scrollToEl(block, false);
        block.classList.remove('is-flash');
        void block.offsetWidth;
        block.classList.add('is-flash');
        var active = qs('.hlshade__opt.is-active', block);
        if (active) setTimeout(function () { active.focus({ preventScroll: true }); }, reduced ? 0 : 450);
        return;
      }
      if (addBtn) addBtn.click();
    });
  }

  /* ---- 5: "find your shade" cards ---- */
  qsa('[data-hl-pick-shade]').forEach(function (b) {
    b.addEventListener('click', function () {
      var value = b.getAttribute('data-value');
      if (!value) return;
      chosen = true;
      if (mix && mix.checked) { mix.checked = false; bundle.classList.remove('is-mixing'); }
      setAll(value, true);
      scrollToEl(block || bundle, false);
      if (block) {
        block.classList.remove('is-flash');
        void block.offsetWidth;
        block.classList.add('is-flash');
      }
    });
  });
})();
